module.exports = __webpack_public_path__ + "img/arrow-left.12b75da8.svg";